import axios from "axios";
import { getFunctions, httpsCallable } from "firebase/functions";
import { TYPES } from "./stripe.type";
import { REGION } from "../ref";
import { app, STRIPE } from "../../config/config";

const functions = getFunctions(app, REGION);

// -------------------------- Upload File --------------------------
export const uploadFile =
  ({ file }, callback) =>
  (dispatch) => {
    const bodyFormData = new FormData();
    bodyFormData.append("file", file);
    bodyFormData.append("purpose", "additional_verification");
    bodyFormData.append("purpose", "identity_document");
    bodyFormData.append("purpose", "document_provider_identity_document");
    axios({
      method: "post",
      url: "https://files.stripe.com/v1/files",
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${STRIPE.FILE}`,
      },
    })
      .then((response) => {
        //handle success
        console.log({ response });
        const status = response.status;
        if (status === 200 && callback) {
          callback(response);
        }
      })
      .catch(function (error) {
        //handle error
        console.log({ error });
      });
  };

export const getFile =
  ({ id }, callback) =>
  (dispatch) => {
    axios({
      method: "get",
      url: "https://files.stripe.com/v1/files/" + id,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${STRIPE.FILE}`,
      },
    })
      .then((response) => {
        const status = response.status;
        if (status === 200 && callback) {
          callback(response);
        }
      })
      .catch(function (error) {
        //handle error
        console.log({ error });
      });
  };

// -------------------------- Create Account --------------------------
export const createAccount =
  ({ accountData }, callback) =>
  (dispatch) => {
    console.log({ accountData });
    const createAccount = httpsCallable(
      functions,
      "party-stripe-account-create"
    );
    createAccount(accountData)
      .then((response) => {
        const data = response.data;
        callback(data);
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error?.message,
          });
        }
      });
  };

export const getAccount =
  ({ id }, callback) =>
  (dispatch) => {
    getStripeAccountSuccess(dispatch, null);
    const getAccount = httpsCallable(
      functions,
      "party-stripe-account-retrieve"
    );
    getAccount({ id })
      .then((response) => {
        const data = response?.data?.data;
        getStripeAccountSuccess(dispatch, data);
        callback(data);
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error?.message,
          });
        }
      });
  };

// -------------------------- Update Account --------------------------
export const updateAccount =
  ({ stripeAccount, accountData }, callback) =>
  (dispatch) => {
    const updateAccount = httpsCallable(
      functions,
      "party-stripe-account-update"
    );
    const update = {
      ...accountData,
      stripeAccount,
    };
    // console.log("accountData", update);
    updateAccount(update)
      .then((response) => {
        const data = response.data;
        callback(data);
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error?.message,
          });
        }
      });
  };

// -------------------------- Update Account --------------------------
export const addBank =
  ({ bank }, callback) =>
  (dispatch) => {
    const addBank = httpsCallable(functions, "party-stripe-tokens-bank");
    addBank(bank)
      .then((response) => {
        const data = response.data;
        callback(data);
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error,
          });
        }
      });
  };

export const addBankToAccount =
  ({ stripeAccount, externalAccount }, callback) =>
  (dispatch) => {
    const addExternalAccount = httpsCallable(
      functions,
      "party-stripe-account-createExternal"
    );
    addExternalAccount({
      stripeAccount,
      externalAccount,
    })
      .then((response) => {
        const data = response.data;
        callback(data);
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error?.message,
          });
        }
      });
  };

// -------------------------- Dispatch --------------------------
const getStripeAccountSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_STRIPE_ACCOUNT_SUCCESS,
    payload: data,
  });
};
